<template>
  <div class="return-funds-overlay">
    <div>
      <p>
        <strong><small>Current Balance</small></strong><br />
        <v-money class="small" currency="USD" locale="en">{{ card.Balance }}</v-money>
      </p>
    </div>
    <div>
      <p><strong><small>Return Amount</small></strong></p>
        <ed-input type='money' v-model="returnFunds" amount @input="(value) => $emit('returnFunds', value)"></ed-input>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    card: Object
  },

  data() {
    return {
      returnFunds: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .return-funds-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/ReturnFundsToAccount.vue